import styled from 'styled-components'

export const ContainerGavetaMostrar = styled.div`
  width: 100%;
  height: calc(100vh - 130px);
  overflow-y: auto;
  box-sizing: border-box;
  display: flex;
  padding-right: 10px;
  flex-direction: column;
  gap: 10px;

  .header__membro {
    display: flex;
    flex-direction: row;
    gap: 15px;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 5px;
  }

  .header__accordion {
    display: flex;
    flex-direction: row;
    gap: 15px;
    align-items: center;
  }

  .icone__modulo {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #e5ffe4ff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 14px;
    color: #5da57d;
  }

  .header__title {
    display: flex;
    flex-direction: column;
    justify-content: center;

    h3 {
      margin: 0;
      padding: 0;
      font-size: 15px;
      font-weight: bold;
      color: #1a202c;
    }

    span {
      margin: 0;
      padding: 0;
      font-size: 11px;
      font-weight: 600;
      color: #a0aec0;
      text-transform: uppercase;
    }
  }

  .tags__container {
    display: flex;
    flex-direction: column;
    gap: 15px;

    .modulo__grupo {
      display: flex;
      flex-direction: column;
      gap: 8px;

      h4 {
        margin: 0;
        padding: 0;
        font-size: 13px;
        font-weight: 600;
        color: #7b7b7b;
      }

      .tags__wrapper {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
      }
    }

    .tag {
      width: fit-content;
      height: 30px;
      padding: 5px 10px;
      border-radius: 5px;
      border: 1px solid #e5ffe4ff;
      background-color: #ffffff;
      color: #5da57d;
      display: flex;
      align-items: center;
      font-size: 12px;
      font-weight: bold;
    }
  }

  /* Sobrescrevendo o Ant Design para criar o visual de Cards separados */
  .ant-collapse {
    background-color: transparent !important;
    border: none !important;

    > .ant-collapse-item {
      background-color: #ffffff;
      border: 1px solid #d9d9d9 !important;
      border-radius: 10px !important;
      margin-bottom: 15px;
      overflow: hidden;

      &:last-child {
        margin-bottom: 0;
      }

      > .ant-collapse-header {
        align-items: center;
        border-radius: 10px !important;
      }

      > .ant-collapse-content {
        border-top: 1px solid #f0f0f0;
      }
    }
  }
`
